export default __webpack_public_path__ + "static/avatar_nobg-cd7ed3696973e7683de8b01e65226bec.png";